export default theme => ({
  root: {
    width: '100%',
    height: '100%'
  },
  content: {
    width: '100%',
    height: 'calc(100% - 60px)'
  },
  loader: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  errorButton: {
    marginTop: '24px'
  },
  emptyButton: {
    marginTop: '24px'
  }
});